export default __webpack_public_path__ + "static/media/fitness.811976a6.png";